import { Tabs } from '@teamsnap/teamsnap-ui';
import { useOrderDetails } from 'hooks/orderDetails';
import * as React from 'react';
import FeesList from './fees-table/fees-table';
import InstallmentsList from './installments/installments-table';
import NotesList from './notes-table';
import TransactionsList from './transactions/transactions-table';

const OrderDetailsTabs = () => {
  const { order } = useOrderDetails();
  return (
    <Tabs
      mods="u-spaceRightSm"
      renderOnload
      tabs={[
        {
          heading: (
            <span
              role="tab"
              tabIndex={0}
              data-testid="order-details-tabs--fees-tab"
            >
              Overview
            </span>
          ),
          content: <FeesList />,
        },
        {
          heading: (
            <span
              role="tab"
              tabIndex={0}
              data-testid="order-details-tabs--transactions-tab"
            >
              Transactions
            </span>
          ),
          content: <TransactionsList />,
        },
        {
          heading: (
            <span
              role="tab"
              tabIndex={0}
              data-testid="order-details-tabs--payment-schedule-tab"
            >
              Payment Schedule
            </span>
          ),
          content: <InstallmentsList />,
        },
        {
          heading: (
            <span
              role="tab"
              tabIndex={0}
              data-testid="order-details-tabs--notes-tab"
            >
              Notes
            </span>
          ),
          content: <NotesList />,
        },
      ]}
    />
  );
};

export default OrderDetailsTabs;
